import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RouterActions } from '@actions/index'
import { debounceTime, Observable, Subject, switchAll } from 'rxjs';
import { TemplatePortal } from '@angular/cdk/portal';
import { CampaignState } from '@enums/campaingState.enum';

export interface RouterLabeled {
  routerLabel$: Observable<ViewLabel>
}

export type ViewLabel = string | {
  title: string,
  subtitle: string,
  shelf?: TemplatePortal<any>,
  largeShelf?: boolean,
  statusIndicator?: CampaignState,
}

@Injectable({
  providedIn: 'root'
})
export class RouterFacadeService {
  constructor(private store: Store<any>) { }

  routerLabels$$ = new Subject<Observable<ViewLabel>>()
  routerLabel$ = this.routerLabels$$.pipe(
    switchAll(),
    debounceTime(1),
  )

  gotoContacts$(urlParam: String) {
    this.store.dispatch(RouterActions.navigateContacts({ urlParam }))
  }

  gotoBusinessDashboard$() {
    this.store.dispatch(RouterActions.navigateBusinessDashboard())
  }

  gotoLocationDashboard$() {
    this.store.dispatch(RouterActions.navigateLocationDashboard())
  }

  gotoAuth$() {
    this.store.dispatch(RouterActions.navigateAuth())
  }

  gotoSignUpProcess$() {
    this.store.dispatch(RouterActions.navigateSignUpProcess())
  }

  gotoPasswordRecover$() {
    this.store.dispatch(RouterActions.navigatePasswordRecover())
  }

  gotoChangePassword$() {
    this.store.dispatch(RouterActions.navigateChangePassword())
  }

  gotoChangePasswordConfirmed$() {
    this.store.dispatch(RouterActions.navigateChangePasswordConfirmed())
  }

  gotoUsers$(urlParam: String) {
    this.store.dispatch(RouterActions.navigateUsers({ urlParam }))
  }

  gotoBusinessProfile$() {
    this.navigateTo$('/admin-business/profile');
  }

  gotoReviewTarget$() {
    this.store.dispatch(RouterActions.navigateReviewTargets())
  }

  gotoReviewTargetLocation$() {
    this.store.dispatch(RouterActions.navigateReviewTargetsLocation())
  }

  gotoReviewTargetForm$() {
    this.store.dispatch(RouterActions.navigateReviewTargetsForm())
  }

  gotoResellers$() {
    this.store.dispatch(RouterActions.navigateResellers())
  }

  gotoResellerProfile$() {
    this.store.dispatch(RouterActions.navigateResellerProfile())
  }

  gotoReviews$() {
    this.store.dispatch(RouterActions.navigateReviews())
  }

  gotoFeedback$() {
    this.store.dispatch(RouterActions.navigateFeedback())
  }

  gotoReports$() {
    this.store.dispatch(RouterActions.navigateReports())
  }

  gotoCampaigns$() {
    this.store.dispatch(RouterActions.navigateCampaigns())
  }

  gotoTemplates$() {
    this.store.dispatch(RouterActions.navigateTemplates())
  }

  gotoWidgets$() {
    this.store.dispatch(RouterActions.navigateWidgets())
  }

  gotoSharing$() {
    this.store.dispatch(RouterActions.navigateSharing())
  }

  navigateTo$(pathUrl: string, queryParams: { [key: string]: string } = {}) {
    this.store.dispatch(RouterActions.navigateTo({ pathUrl, queryParams }))
  }
}
